import styled from "styled-components";
import { TextField } from "@mui/material";
import { InputPropsI } from "./Input.component";

export const InputContainer = styled.div<{ sizeContainer?: "auto" | "small" }>`
  display: flex;
  flex-direction: column;
  width: ${({ sizeContainer = "auto" }) =>
    sizeContainer === "small" ? "41px" : "auto"};
`;

export const InputLabel = styled.label<{ enabled?: boolean }>`
  color: ${(props) => {
    if (!props.enabled) {
      return "#A3AFD1";
    }
    return "#1B2852";
  }};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.15000000596046448px;
  text-align: left;
  padding-bottom: 16px;
`;

export const InputStyled = styled(TextField)<InputPropsI>`
  & label.Mui-focused {
    color: white;
  }

  & .MuiOutlinedInput-root {
    background-color: ${(props) => (props.filled ? "#F3F6FF" : "")};
    border: ${(props) => (props.filled ? "1px solid #D9DFF8" : "")};
    font-family: "AvertaPE";
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0.15000000596046448px;
    text-align: left;
    & .MuiOutlinedInput-input {
      font-family: "AvertaPE";
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px;
      letter-spacing: 0.15000000596046448px;
      text-align: left;
      color: #1b2852;
    }
    &.Mui-disabled input {
      cursor: not-allowed;
    }
    &.Mui-focused fieldset {
      border: 1px solid #a3afd1;
    }
  }
`;

export const ErrorLabel = styled.h5`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 21px;
  color: #d20e0e;
  margin: 0;
  padding-bottom: 8px;
`;
